const sanitizeFormData = (data = {}) => {
  return Object.fromEntries(
    Object.entries(data).map(([key, value]) => [
      key,
      value === '-' ? '' : value,
    ])
  );
};

export { sanitizeFormData };
